import { Button } from '@rocketmakers/armstrong';
import * as React from 'react';
import { useRoutePaths } from '../../../../shared/context/paths';
import { routePaths } from '../../routes';
import './home.scss';

export const HomeView: React.FunctionComponent = () => {
  const { push } = useRoutePaths();
  const handleStart = () => push(routePaths.check.root);

  return (
    <div className="home">
      <Button className="btn-outline activate-sim-button" disabled>
        Activate sim card
      </Button>
      <Button className="start-button" onClick={handleStart}>
        Start Commissioning
      </Button>
    </div>
  );
};
